import { Details } from 'components/atoms';
import Image from 'next/legacy/image';
import React from 'react';
import { NationaleMarke, WarenDienstleistung } from 'types/unternehmen';
import { useTranslation } from 'utils/hooks';
import { TranslationKey } from 'utils/hooks/useTranslation';

import css from './NationaleMarke.module.scss';

const WarenDienstleistungUI: React.FC<{ data: WarenDienstleistung }> = (props) =>
{
  const { data } = props;
  const { r } = useTranslation('formats');

  return (
    <div className={css.warenDienstleistung}>
      {r('formats:warenDienstleistung', undefined, { value: data })}
    </div>
  );
};

interface NationaleMarkeUIProps
{
  data: NationaleMarke;
  id: string;
}

const NationaleMarkeUI: React.FC<NationaleMarkeUIProps> = (props) =>
{
  const { data, id } = props;
  const { t } = useTranslation(['formats', 'profiles', 'marken']);

  return (
    <li id={id} className={css.container}>

      <h4 className={css.title}>{ `${data.name} (${data.art})` }</h4>

      {
        // Display image if Wort-Bild
        data.pfad && (
          <div className={css.imageContainer}>
            <Image
              src={`/api/images/bildmarken/${data.pfad}`}
              alt={data.name}
              layout="fill"
              objectFit="contain"
              objectPosition="center"
            />
          </div>
        )
      }

      <table className={css.table}>
        <tbody>

          <tr>
            <th>{t('profiles:marken.status')}</th>
            <td>{t(`marken:status.${data.status}` as TranslationKey)}</td>
          </tr>

          {data.registerdatum && (
            <tr>
              <th>{t('profiles:marken.registerDate')}</th>
              <td>{ t('formats:date', { value: data.registerdatum }) }</td>
            </tr>
          )}

        </tbody>
      </table>

      <Details>
        <table className={css.table}>
          <tbody>

            {data.anmeldedatum && (
              <tr>
                <th>{t('profiles:marken.createDate')}</th>
                <td>{ t('formats:date', { value: data.anmeldedatum }) }</td>
              </tr>
            )}

            {data.publikationsdatum && (
              <tr>
                <th>{t('profiles:marken.publicationDate')}</th>
                <td>{ t('formats:date', { value: data.publikationsdatum }) }</td>
              </tr>
            )}

            {data.widerspruch && data.widerspruch !== 'keiner' && (
              <tr>
                <th>{t('profiles:marken.contradiction')}</th>
                <td>{ data.widerspruch }</td>
              </tr>
            )}

            {data.warenDienstleistungen && (
              <tr>
                <th>{t('profiles:marken.services')}</th>
                <td>{ data.warenDienstleistungen.map((ware) => <WarenDienstleistungUI key={ware.beschreibung} data={ware} />) }</td>
              </tr>
            )}

          </tbody>
        </table>
      </Details>

    </li>
  );
};

export default NationaleMarkeUI;
